import routerMixin from './router'
import { imgZip, imgCut } from '../filters/ossImg'

export default {
  mixins: [routerMixin],
  filters: {
    imgZip,
    imgCut
  },
  methods: {
    toFixed(num) {
      return num > 10 ? num : '0' + num
    },
    /**
     * 格式化时间
     * @param {number} t
     */
    parseTime(t) {
      const day = parseInt(t / parseInt(1000 * 60 * 60 * 24))
      t = t % parseInt(1000 * 60 * 60 * 24)
      const hour = parseInt(t / parseInt(1000 * 60 * 60))
      t = t % parseInt(1000 * 60 * 60)
      const min = parseInt(t / parseInt(1000 * 60))
      t = t % parseInt(1000 * 60)
      const sec = parseInt(t / parseInt(1000))
      return { day, hour, min, sec }
    }
  }
}
